import React from 'react';
import { AutocompleteBase } from 'components';

const AutocompleteKeywords = ({ setter, settings = null, selected = null }) => {
  settings = settings ?? {};
  settings['@resourceType'] = 'digitalAssetsKeyword';
  settings.displayLabel = false;
  settings.fullObjects = true;
  settings.multiple = true;
  settings.allowNew = true;

  return (
    <AutocompleteBase setter={setter} settings={settings} selected={selected} />
  );
};

export default AutocompleteKeywords;
